/**
 * CampoTesto — il campo di testo del costruttore: valore sempre stringa (mai undefined, così
 * React non passa da campo libero a campo controllato), `onChange` che riceve il testo.
 */

import React from 'react';
import { TextField, type TextFieldProps } from '@mui/material';

type Props = Omit<TextFieldProps, 'value' | 'onChange'> & {
  value: string | undefined | null;
  onChange: (valore: string) => void;
};

export const CampoTesto: React.FC<Props> = ({ value, onChange, size = 'small', fullWidth = true, ...resto }) => (
  <TextField
    {...resto}
    size={size}
    fullWidth={fullWidth}
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value)}
  />
);

/** Un intero facoltativo da un campo di testo: vuoto = undefined. */
export function interoDa(testo: string): number | undefined {
  const t = testo.trim();
  if (!t) return undefined;
  const n = Number(t);
  return Number.isInteger(n) ? n : undefined;
}
